import { useEffect, useRef, useState } from "react";

export const useReveal = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && (setInView(true), io.disconnect()), { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return [ref, inView];
};

export const useCountUp = (target, run, ms = 1400) => {
  const [n, setN] = useState(0);
  const from = useRef(0);
  useEffect(() => {
    if (!run) return;
    let raf;
    const start = performance.now();
    const base = from.current;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / ms);
      const v = Math.round(base + (target - base) * (1 - Math.pow(1 - p, 3)));
      from.current = v;
      setN(v);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, run, ms]);
  return n;
};
